<template>
  <div class="list-img-container">
    <template v-for="(src, index) in list">
      <img :key="index" v-if="index < limit" v-viewerer="list" :src="src | ossStyle(width)" :width="width" alt="" />
    </template>
  </div>
</template>

<script>
export default {
  name: 'ListImg',
  props: {
    img: {
      type: [String, Array],
    },
    limit: {
      type: Number,
      default: 1,
    },
    width: {
      type: Number,
      default: 40,
    },
  },
  filters: {
    'ossStyle': (value, width) => {
      if (!value) {
        return '';
      }
      if (value.indexOf('aliyuncs.com') > 0) {
        width = width || 40;
        return `${value}?x-oss-process=image/auto-orient,1/resize,m_lfit,w_${width}/quality,q_100/format,jpg`;
      }
      return value;
    }
  },
  computed: {
    list() {
      let temp = [];
      if (!this.img) {
        return temp;
      }
      if (this.img instanceof Array) {
        return this.img;
      }
      if (this.img.indexOf('[') === 0) {
        try {
          temp = JSON.parse(this.img);
        } catch (e) {
          console.error('img parse error', e);
        }
      } else {
        temp = [this.img];
      }
      return temp;
    },
  },
};
</script>

<style scoped lang="less">
.list-img-container {
  font-size: 0;
  padding: 5px 0;
  text-align: center;
  img {
    vertical-align: middle;
  }

  img + img {
    margin-left: 10px;
  }
}
</style>
